module.exports = "<ul #list>\n  <li *ngFor=\"let item of items; let i = index;\">\n    <edit type=\"textarea\" [value]=\"item\" (keydown)=\"keyPress($event, i)\" [field]=\"'list.'+i\"></edit>\n    <div (click)=\"removeItem(i)\" class=\"delete ion-ios-close\"></div>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/list/list.component.html
// module id = 194
// module chunks = 1